import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { get } from 'lodash';
import {
	SdfAlert,
	SdfBox,
	SdfBusyIndicator,
	SdfButton,
	SdfFocusPane,
	SdfRadioButton,
	SdfRadioGroup,
	SdfSelect,
	SdfWizardLayout,
	SdfWizardStepsVertical,
	SdfWizardStepsVerticalItem,
} from '@synerg/react-components';
import { figureOutCategories } from '../../../common';
import { ScopeStep } from './scopeStep';
import { ReviewScopeChangesStep } from './reviewScopeStep';
import { ReviewAuthTextStep } from './reviewAuthTextStep';
import { SubmitScopeStep } from './submitScopeStep';

export const ModifiyScope = (props = {}) => {
	const {
		projectID,
		prodProjectID,
		loadModifyScope,
		setLoadModifyScope,
		projectDetails,
		activeChangeRequest,
		carDetails,
		setModifyScopeSuccess
	} = props || {};

	// common states
	const [loading, setLoading] = useState(false);
	const [isError, setError] = useState(false);
	const [showToast, setShowToast] = useState(false);
	const [infoMessage, setInfoMessage] = useState(null);

	const [loadContent, setLoadContent] = useState('CONFIRMATION'); //CONFIRMATION //CONTENT
	const [projectTypeDpList, setProjectTypeDpList] = useState([
		{ value: 'DEV', label: 'Development project' }
	]);
	const [selectedUserProjectType, setSelectedUserProjectType] = useState('DEV');
	const [applicationType, setApplicationType] = useState('');
	const [b2bConsumerAppID, setB2bConsumerAppID] = useState('');
	const [b2cConsumerAppID, setB2cConsumerAppID] = useState('');

	const [activeStep, setActiveStep] = useState(0);
	const [b2cScopes, setB2CScopes] = useState([]);
	const [b2bScopes, setB2BScopes] = useState([]);
	const [b2bCategories, setb2bCategories] = useState([]);
	const [b2cCategories, setb2cCategories] = useState([]);
	const [preSelectedScopes, setPreSelectedScopes] = useState([]);
	const [preSelectedAuthTexts, setPreSelectedAuthTexts] = useState([]);
	const [consentsUpdated, setConsentsUpdated] = useState(false);
	const [scopesUpdated, setScopesUpdated] = useState(false);
	const [data, setData] = useState({ projectID: projectID });
	const [cutOffDate, setCutOffDate] = useState();
	const [completed, setCompleted] = useState(false);

	const isB2bScopes = applicationType === 'B2B';
	const subsCount = selectedUserProjectType === 'DEV'
		? get(carDetails, 'subscriptionsTotal', 0)
		: get(carDetails, 'prod.subscriptionsTotal', 0);

	const associatedProjectType = get(projectDetails.associatedProject, 'type', 'null');

	useEffect(() => {
		if (isB2bScopes) {
			setPreSelectedScopes(selectedUserProjectType === 'DEV'
				? (carDetails && carDetails.b2bListOfScopes) || []
				: (carDetails && carDetails.prod && carDetails.prod.b2bScopes) || []
			);
			setPreSelectedAuthTexts(selectedUserProjectType === 'DEV'
				? (carDetails && carDetails.b2bConsentTexts) || ''
				: (carDetails && carDetails.prod && carDetails.prod.b2bConsents) || ''
			);
		} else {
			setPreSelectedScopes(selectedUserProjectType === 'DEV'
				? (carDetails && carDetails.b2cListOfScopes) || []
				: (carDetails && carDetails.prod && carDetails.prod.b2cScopes) || []
			);
			setPreSelectedAuthTexts(selectedUserProjectType === 'DEV'
				? (carDetails && carDetails.b2cConsentTexts) || ''
				: (carDetails && carDetails.prod && carDetails.prod.b2cConsents) || ''
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [applicationType]);

	useEffect(() => {
		getScopes(isB2bScopes);
		projectTypeChangeHandler(selectedUserProjectType);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedUserProjectType]);

	useEffect(() => {
		if (!projectID && prodProjectID && prodProjectID.length > 0) {
			setProjectTypeDpList([
				{ value: 'PROD', label: 'Production project' }
			]);
			setSelectedUserProjectType('PROD');
		} else if (prodProjectID && prodProjectID.length > 0) {
			setProjectTypeDpList([
				{ value: 'DEV', label: 'Development project' },
				{ value: 'PROD', label: 'Production project' }
			]);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [prodProjectID]);

	const getScopes = async (isB2B = false) => {
		if (isB2B) {
			const { data } = await axios(
				`${import.meta.env.VITE_ROOT_PATH}/api/scopes?grantType=clientCredentials`
			);
			setB2BScopes(data);
			setb2bCategories(figureOutCategories(data));
		} else {
			const { data } = await axios(
				`${import.meta.env.VITE_ROOT_PATH}/api/scopes?grantType=authorizationCode`
			);
			setB2CScopes(data);
			setb2cCategories(figureOutCategories(data));
		}
	};

	const projectTypeChangeHandler = (value) => {
		setApplicationType('');
		setSelectedUserProjectType(value);

		let b2bConsumerAppID = '';
		let b2cConsumerAppID = '';
		let selectedProjectID = '';

		if ((value === 'PROD' && associatedProjectType === 'PROD') || (value === 'DEV' && associatedProjectType === 'DEV')) {
			b2bConsumerAppID = get(projectDetails.associatedProject, 'b2bConsumerAppID', '');
			b2cConsumerAppID = get(projectDetails.associatedProject, 'b2cConsumerAppID', '');
			selectedProjectID = value === 'PROD' ? prodProjectID : projectID;
		} else {
			b2bConsumerAppID = get(projectDetails, 'b2bConsumerAppID', '');
			b2cConsumerAppID = get(projectDetails, 'b2cConsumerAppID', '');
			selectedProjectID = value === 'PROD' ? prodProjectID : projectID;
		}

		setB2bConsumerAppID(b2bConsumerAppID);
		setB2cConsumerAppID(b2cConsumerAppID);
		setData({ ...data, environment: value, consumerApplicationID: '', selectedProjectID });
	};

	const applicationTypeChangeHandler = (type) => {
		getScopes(type === 'B2B');
		setApplicationType(type);
		setData({
			...data,
			applicationType: type,
			consumerApplicationID: type === 'B2B' ? b2bConsumerAppID : b2cConsumerAppID
		});
	};

	const launchScopeWizardHandler = () => {
		setLoadContent('CONTENT');
	};

	const nextButtonHandler = () => {
		if (activeStep === 2) {
			if (subsCount > 0 && isB2bScopes && selectedUserProjectType === 'PROD' && consentsUpdated) {
				setActiveStep(activeStep + 1);
			} else submitChangeRequest();
		} else setActiveStep(activeStep + 1);
	};

	const submitChangeRequest = async () => {
		setError(false);
		setShowToast(false);
		if (consentsUpdated || scopesUpdated) {
			setLoading(true);
			setError(false);
			setShowToast(false);

			const isPreAuthRequired = subsCount > 0 && isB2bScopes && selectedUserProjectType === 'PROD' && consentsUpdated;

			const {
				selectedProjectID,
				consumerApplicationID,
				b2bApplicationScopes,
				b2cApplicationScopes,
				proposedConsentTexts
			} = data;

			const payload = {
				projectID: selectedProjectID,
				consumerApplicationID,
				proposedConsentTexts: proposedConsentTexts || [],
				proposedScopes: isB2bScopes ? b2bApplicationScopes : b2cApplicationScopes,
				hasSubscriptions: subsCount > 0
			};

			if (isPreAuthRequired) {
				payload['cutOffDate'] = cutOffDate;
			}

			try {
				const { data: { success } } = await axios.post(`${import.meta.env.VITE_ROOT_PATH}/api/project/change-request`, {
					...payload
				});
				if (success) {
					setCompleted(true);
					setActiveStep(3);
				}
				setLoading(false);
			} catch (error) {
				const errorMessage = get(error, 'response.data.message',
					'Something went wrong when trying to update email list. Please try again.'
				);
				setError(true);
				setShowToast(true);
				setInfoMessage(errorMessage);
				setLoading(false);
			}
		} else {
			setError(true);
			setShowToast(true);
			setInfoMessage('Either Scopes or consent texts should be modified to create a change request.');
		}
	};

	const hasB2BProdActiveChangeRequest =
		selectedUserProjectType === 'PROD' &&
		get(activeChangeRequest, 'PROD.applicationType', '') === 'B2B' &&
		get(activeChangeRequest, 'PROD.environment', '') === 'PROD';

	return (
		<div className="w-full">
			<SdfFocusPane
				visible={loadModifyScope}
				closeable={true}
				dismissOnClickOutside={true}
				heading={"Modify app scope"}
				hideAcceptButton={true}
				hideDismissButton={true}
				onSdfDismiss={() => setLoadModifyScope(false)}
				spacing={"loose"}
				size={loadContent === "CONFIRMATION" ? "lg" : "xl"}
			>
				{loading ? (
					<SdfBusyIndicator
						style={{ color: "#1a8099" }}
						size="xl"
						fullScreen={true}
						overlay={true}
					/>
				) : null}

				<SdfAlert
					className="fixed min-w-1/3"
					style={{ top: "6rem", right: "calc(100% - 66%)", zIndex: "9999" }}
					hidden={!showToast}
					autoClose={true}
					autoCloseAfter={10000}
					closeable={true}
					useAnimation={true}
					status={isError ? "error" : "success"}
				>
					{infoMessage}
				</SdfAlert>

				{loadContent === "CONFIRMATION" ? (
					<div className="w-full">
						<div className="text-body-02">
							Tell us a little bit more about your change request. Launch wizard to change scope.
						</div>

						<SdfBox variant={"bordered"} className="mt-8">
							<div className="flex items-center">
								<div className="w-2/3 text-heading-03 font-bold">
									Is this scope change for a dev or production project?
								</div>
								<div className="w-1/3">
									<SdfSelect
										hideLabel={true}
										placeholder="Select Project Type"
										className="w-full"
										items={projectTypeDpList}
										onSdfChange={({ detail }) =>
											projectTypeChangeHandler(detail.value)
										}
										value={{
											value: selectedUserProjectType,
											label: selectedUserProjectType === 'DEV' ? 'Development project' : 'Production project'
										}}
									>
									</SdfSelect>
								</div>
							</div>
						</SdfBox>
						<SdfBox variant={"bordered"} className="mt-8">
							<div className="flex items-center">
								<div className="w-2/3 text-heading-03 font-bold">
									Which application type requires a change?
								</div>
								<div className="w-1/3 flex justify-center">
									<SdfRadioGroup
										onSdfChange={({ detail }) =>
											applicationTypeChangeHandler(detail.value)
										}
										hideLabel={true}
										direction={"row"}
										value={applicationType}
									>
										<SdfRadioButton
											label="B2B"
											value="B2B"
											disabled={!b2bConsumerAppID || hasB2BProdActiveChangeRequest === true ? true : undefined}
										/>
										<SdfRadioButton
											label="B2C"
											value="B2C"
											disabled={!b2cConsumerAppID === true ? true : undefined}
										/>
									</SdfRadioGroup>
								</div>
							</div>
						</SdfBox>
						<SdfBox variant={"bordered"} className="mt-8">
							<div className="flex items-center">
								<div className="w-2/3 text-heading-03 font-bold">
									Change app scope?
								</div>
								<div className="w-1/3 flex justify-center">
									<SdfButton
										emphasis="primary"
										onClick={() => launchScopeWizardHandler()}
										disabled={(!b2bConsumerAppID && !b2cConsumerAppID) || !applicationType ? true : undefined}
									>
										Launch scope wizard
									</SdfButton>
								</div>
							</div>
						</SdfBox>
					</div>
				) : null}
				{loadContent === "CONTENT" ? (
					<div className="w-full flex">
						<div className="w-1/4">
							<SdfWizardLayout>
								<SdfWizardStepsVertical slot="wizard-steps" class="w-xs">
									<SdfWizardStepsVerticalItem isCurrent={activeStep === 0}>
										Add APIs
									</SdfWizardStepsVerticalItem>
									<SdfWizardStepsVerticalItem isCurrent={activeStep === 1}>
										Review scope change
									</SdfWizardStepsVerticalItem>
									<SdfWizardStepsVerticalItem isCurrent={activeStep === 2}>
										Review auth text
									</SdfWizardStepsVerticalItem>
									<SdfWizardStepsVerticalItem isCurrent={activeStep === 3}>
										Next steps
									</SdfWizardStepsVerticalItem>
								</SdfWizardStepsVertical>
							</SdfWizardLayout>
						</div>
						<div className="w-3/4">
							{activeStep === 0 ? (
								<ScopeStep
									isB2bScopes={isB2bScopes}
									categories={isB2bScopes ? b2bCategories : b2cCategories}
									scopes={isB2bScopes ? b2bScopes : b2cScopes}
									data={data}
									setData={setData}
									preSelectedScopes={preSelectedScopes}
									preSelectedAuthTexts={preSelectedAuthTexts}
								/>
							) : null}

							{activeStep === 1 ? (
								<ReviewScopeChangesStep
									isB2bScopes={isB2bScopes}
									data={data}
									setData={setData}
									preSelectedScopes={preSelectedScopes}
									preSelectedAuthTexts={preSelectedAuthTexts}
									setScopesUpdated={setScopesUpdated}
								/>
							) : null}

							{activeStep === 2 ? (
								<ReviewAuthTextStep
									isB2bScopes={isB2bScopes}
									data={data}
									setData={setData}
									preSelectedAuthTexts={preSelectedAuthTexts}
									setConsentsUpdated={setConsentsUpdated}
								/>
							) : null}

							{activeStep === 3 ? (
								<SubmitScopeStep
									completed={completed}
									cutOffDate={cutOffDate}
									setCutOffDate={setCutOffDate}
									submitChangeRequest={submitChangeRequest}
									setLoadModifyScope={setLoadModifyScope}
									setModifyScopeSuccess={setModifyScopeSuccess}
								/>
							) : null}
						</div>
					</div>
				) : null}

				<SdfButton slot="custom-buttons" onClick={() => setLoadModifyScope(false)}>
					Cancel
				</SdfButton>
				{loadContent === "CONTENT" && activeStep !== 3 ? (
					<>
						<SdfButton
							slot="custom-buttons"
							icon={"nav-move-left"}
							onClick={() => setActiveStep(activeStep - 1)}
							disabled={activeStep === 0 ? true : undefined}
						>
							Back
						</SdfButton>
						<SdfButton
							slot="custom-buttons"
							emphasis="primary"
							icon={"nav-move-right"}
							iconPlacement={"after"}
							onClick={nextButtonHandler}
							disabled={activeStep === 3 ? true : undefined}
						>
							Next
						</SdfButton>
					</>
				) : null}
			</SdfFocusPane>
		</div>
	);
};
